export default __webpack_public_path__ + "afc45c6c44ee55751ce6058e0362e3a8.svg";